import ROUTES from "../../../consts/routes.json";
import Home from "../../../components/Support/Home";

export default {
    component: Home,
    exact: true,
    id: "support_home",
    url: ROUTES.SUPPORT,
    hidePageHeader: true,
};
